import React from "react";
import PropTypes from "prop-types";

import banner1_300 from "assets/banners/luckyclover/300_01.jpg";
import banner1_728 from "assets/banners/luckyclover/728_01.jpg";
import banner1_970 from "assets/banners/luckyclover/970_01.jpg";
/*
import banner1_300 from "assets/banners/Crypto Bit Game/Variation - 1/300x300 - 1.png";
import banner1_728 from "assets/banners/Crypto Bit Game/Variation - 1/728x90 - 1.png";
import banner1_970 from "assets/banners/Crypto Bit Game/Variation - 1/970x90 - 1.png";
*/
// import banner2_970 from "assets/banners/Crypto Bit Game/Variation - 2 -30/970x90 (30).png";
// import banner3_970 from "assets/banners/Crypto Bit Game/Variation - 3- Final/970x90 - Final.png";


function Banner({...props}) {
    const {style} = props;
    const defaultStyle = {
        width: '100%'
    }
    const url = 'https://luckyclover.io/?referral_code=EGN-LVR-X9GOE5RSUA2XYXP5GWJB';
    let banner;

    if (window.matchMedia("(max-width: 600px)").matches) {
        banner = banner1_300;
    } else if( window.matchMedia("(max-width: 970px)").matches )  {
        banner = banner1_728;
    } else {
        banner = banner1_970;
    }
    return <a href={ url } style={ Object.assign(defaultStyle, style)} target="_blank" rel="noopener">
    	<img src={ banner } style={ Object.assign(defaultStyle, style)} alt="luckyclover" />
    </a>
}

Banner.propTypes = {
    style: PropTypes.object,
};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banners/Banner.jsx